import { createContext, useContext, useState } from 'react';
export const MetadataContext = createContext();

export const MetadataProvider = ({ children }) => {
    const [current, setCurrent] = useState();
    const [subCurrent, setSubCurrent] = useState();
    const [isSubMain, setIsSubMain] = useState();
    const [key, setKey] = useState();
    const [selectData, setSelectData] = useState();
    const values = {
        current,
        setCurrent,
        subCurrent,
        setSubCurrent,
        key,
        setKey,
        setIsSubMain,
        isSubMain,
        selectData,
        setSelectData
    };
    return (
        <MetadataContext.Provider value={values}>
            {children}
        </MetadataContext.Provider>
    );
};

export const useMetadataContext = () => useContext(MetadataContext);
